
import { common as ptBRCommon } from './pt-BR/common';
import { common as enCommon } from './en/common';

const messages = {
  'pt-BR': {
    translation: ptBRCommon
  },
  en: {
    translation: enCommon
  }
};

export default messages;
